import { useEffect, useState } from "react";
import "./index.css";
import Header from "../../../common/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Input, Select } from "antd";
import ApiService from "../../../../Service/ApiService";
import UploadInput from "../../../common/upload/UploadInput";
import "../../../common/forms.css";
const { TextArea } = Input;

const currencyOptions = [
  { label: "USD", value: "USD" },
  { label: "FBu", value: "FBu" },
];

const CreateHotel = () => {
  const location = useLocation();
  const [hotel, setHotel] = useState();
  const [admins, setAdmins] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location && location.state?.hotel) {
      const hotelData = location.state.hotel;
      setHotel(hotelData);
      
      // Set form values, handling the image URL properly
      const formValues = { ...hotelData };
      if (hotelData.hotelImage) {
        formValues.hotelImage = hotelData.hotelImage;
      }
      form.setFieldsValue(formValues);
    }
    
    const fetchUsers = async () => {
      let users = await ApiService.getUsersByRole("ADMIN");
      let userOptions = users.map((x) => {
        return {
          label: x.name,
          value: x.id,
        };
      });
      setAdmins(userOptions);
    };
    fetchUsers();
  }, [location, form]);

  const handleSubmit = async (values) => {
    if (hotel) values.version = hotel.version;
    
    if(typeof values.hotelImage === "string")
      values.hotelImage = undefined;
    // Handle image upload
    if (values.hotelImage && typeof values.hotelImage !== "string" && values.hotelImage.length > 0) {
      const imageFile = values.hotelImage[0];
      // If it's a new upload, it will have originFileObj
      if (imageFile.originFileObj) {
        values.hotelImage = imageFile.originFileObj;
      } else if (imageFile.url) {
        // If it's an existing URL (from editing), keep the URL
        values.hotelImage = imageFile.url;
      }
    }
    
    setLoading(true);
    let result;
    if (hotel) {
      const hotelId = hotel.id;
      result = await ApiService.updateHotel(hotelId, values);
    } else {
      result = await ApiService.addHotel(values);
    }
    if (result) {
      navigate(-1);
    }
    setLoading(false);
  };

  return (
    <div className="default-container">
      <Header title={hotel ? "Manage Hotel Details" : "Create a new Hotel"} />
      <div className="form-page-container">
        <Form
          name="hotel-form"
          initialValues={hotel}
          onFinish={handleSubmit}
          form={form}
          layout="vertical"
        >
         <Form.Item
          name={"hotelImage"}
          label="Image of the Hotel"
          rules={[{ required: true, message: "This field is required" }]}
          getValueFromEvent={(e) => e}
          valuePropName="value"
        >
          <UploadInput
            allowedFileTypes={["image/png", "image/jpg", "image/jpeg"]}
            name={"hotelImage"}
          />
        </Form.Item>
          <Form.Item
            label="Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Please input a Hotel name!",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Address"
            name="address"
            rules={[
              {
                required: true,
                message: "Please input a Hotel address!",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[
              {
                required: true,
                message: "Please input a Hotel description!",
              },
            ]}
          >
            <TextArea rows={5} size="large" />
          </Form.Item>
          <Form.Item
            label="Currency"
            name="currency"
            rules={[
              {
                required: true,
                message: "Please input a Hotel currency!",
              },
            ]}
          >
            <Select options={currencyOptions} size="large" />
          </Form.Item>
          <Form.Item
            label="Manager"
            name="manager"
            rules={[
              {
                required: true,
                message: "Please select a hotel manager",
              },
            ]}
          >
            <Select options={admins} size="large" />
          </Form.Item>
          <Form.Item className="action-button-default">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              disabled={loading}
            >
              Save
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default CreateHotel;
